import { createReducer, on } from '@ngrx/store';
import * as TagsActions from './tags.actions';
import { TagsState } from './tags.state';
import { ITag } from '../model/tag.model';

export const initialTagsState: TagsState = {
  tags: [] as ITag[]
};
 
export const tagsReducer = createReducer(
    initialTagsState,
    on( TagsActions.tagsActions.getTagsSuccess, (state , { tags }) => ({ 
      ...state, 
      tags: tags
    })),
    on( TagsActions.tagsActions.deleteTagSuccess, (state , { tag }) => ({ 
      ...state, 
      tags: [...state.tags.filter(x => x.id !== tag.id)]
    })),
    on( TagsActions.tagsActions.editTagSuccess, (state , { tag }) => ({ 
      ...state, 
      tags: [...state.tags.filter(x => x.id !== tag.id), tag ]
    })),
    on( TagsActions.tagsActions.createTagSuccess, (state , { tag }) => ({ 
      ...state, 
      tags: [...state.tags, tag]
    }))
);
